import React, { useState } from 'react';

const initialValues = {
    Imax: '',
    T50: '',
    Iac: '',
    date: ''
}

const IrushCurrentForm = ({ change }) => {
    const [state, setState] = useState(initialValues);



    const handleChange = e => {
        let { value, name } = e.target;

        if (value > 9999) {
            value = 9999;
        }
        const date = new Date().toLocaleString();
        
        setState({
            ...state,
            [name]: value,
            date
        });
    };

    const handleSubmit = () => {
        change(state);
        setState(initialValues);
    };

    return (
        <>
            <div className="row headrow">
                <div className="col l3 m4 s12">
                    <label htmlFor="Imax">Inrush current Imax (A)</label>
                    <input
                        id="Imax"
                        name="Imax"
                        type="number"
                        min="0"
                        max="999"
                        placeholder="53"
                        value={state.Imax}
                        onChange={handleChange}
                    />
                </div>

                <div className="col l3 m4 s12">
                    <label htmlFor="T50">Irush current T50 (us)</label>
                    <input
                        id="T50"
                        name="T50"
                        type="number"
                        min="1"
                        max="9999"
                        placeholder="178"
                        value={state.T50}
                        onChange={handleChange}
                    />
                </div>

                <div className="col l3 m4 s12">
                    <label htmlFor="Iac">Input Current 230VAC (A)</label>
                    <input
                        id="Iac"
                        name="Iac"
                        type="number"
                        min="0"
                        max="999"
                        placeholder="0.2"
                        value={state.Iac}
                        onChange={handleChange}
                    />
                </div>

                <div className="col l3 s12">
                    <button
                        id="Irs-btn"
                        className="calculate-btn"
                        type="button"
                        disabled={state.Imax === '' || state.T50 === '' }
                        onClick={handleSubmit}
                    >
                        Calculate
				    </button>
                </div>
            </div>
        </>
    );
};



export default IrushCurrentForm;